import { render, staticRenderFns } from "./PreChangePassWord.vue?vue&type=template&id=2585eab2&scoped=true&"
import script from "./PreChangePassWord.vue?vue&type=script&lang=js&"
export * from "./PreChangePassWord.vue?vue&type=script&lang=js&"
import style0 from "./PreChangePassWord.vue?vue&type=style&index=0&id=2585eab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585eab2",
  null
  
)

export default component.exports